import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment.default';

export interface HeadersType {
  [key: string]: string;
}
export interface IApiBaseActions {
  Get(url: string, params?: HeadersType): Observable<unknown>;

  Post(url: string, data: any, params?: HeadersType): Observable<unknown>;
}

@Injectable({
  providedIn: 'root',
})
export class ApiHandlerService implements IApiBaseActions {
  constructor(private httpClient: HttpClient) {}

  Get(
    url: string,
    headers?: HeadersType,
    isResponseTypeText = false
  ): Observable<any> {
    const options: any = {
      headers: this.createParams(headers),
    };

    if (isResponseTypeText) {
      options.responseType = 'text';
    }

    return this.httpClient.get(url, options);
  }

  Post<TRequest, TResponse>(
    url: string,
    data: TRequest,
    headers?: HeadersType
  ): Observable<TResponse> {
    return this.httpClient.post<TResponse>(url, data, {
      headers: this.createParams(headers),
    });
  }

  createParams(headers?: HeadersType): HttpHeaders {
    let httpParams = new HttpHeaders();
    if (headers) {
      Object.entries(headers).forEach(([key, value]) => {
        httpParams = httpParams.append(key, value);
      });
    }
    return httpParams;
  }

  getACSBaseUrl(resourceName: string, nameSpace = 'datawarehouse'): string {
    return `${environment.BASE_ACS_URL}acs-proxy?resourceName=${resourceName}&namespace=${nameSpace}`;
  }
}
